import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, currencyNegativeAndPositiveMask, phoneMask } from '~/utils/masks';

const statusTransactionDisplay = {
  COMPLETE: 'COMPLETA',
  REVERSE: 'ESTORNADA',
  CANCELED: 'CANCELADA'
};

export interface SalesObject {
  authorizerIdOrigin: string;
  companyName: string;
  companyCode: string;
  cardNumber: string;
  purchaseDate: string;
  purchaseTime: string;
  purchaseValue: number;
  installmentValue: number;
  purchasePlan: string;
  installments: string;
  dueDate: string;
  amountToReceive: number;
  repassCondition: string;
  receiptDate: string;
  receiptDateRule: string;
  mdrFee: number;
  nsuIntegrator: string;
  nsuTef: string;
  salesChannel: string;
  nickname: string;
  nsu: number;
  statusTransaction: string;
  category?: string;
  c5Classification?: string;
}
export interface RepassObject {
  companyName: string;
  companyCode: string;
  paymentId: any;
  bankCode: string;
  branch: string;
  account: string;
  digit: string;
  totalAmount: number;
  receiptDate: string;
  nsuIntegrator: string;
  nsuTef: string;
  nsu: number;
}

export const HeaderRepass = [
  {
    label: 'Descrição EC',
    key: 'companyName',
  },
  {
    label: 'CNPJ EC',
    key: 'companyCode',
  },
  {
    label: 'ID Pagamento',

    key: 'paymentId',
  },
  {
    label: 'Banco',
    key: 'bankCode',
  },
  {
    label: 'Agencia',
    key: 'branch',
  },
  {
    label: 'Conta corrente',
    key: 'account',
  },
  {
    label: 'Digito',
    key: 'digit',
  },
  {
    label: 'Valor total líquido',
    key: 'totalAmount',
  },
  {
    label: 'Data de repasse',
    key: 'receiptDate',
  },
  {
    label: 'NSU Integrador',
    key: 'nsuIntegrator'
  },
  {
    label: 'NSU Tef',
    key: 'nsuTef',
  },
  {
    label: 'NSU',
    key: 'nsu'
  }
];

export const BodySales = (data: SalesObject[]) => {
  // let x = 0;

  const items = [];

  data?.forEach((i) => {
    items.push({
      ...i,
      purchaseValue: `R$ ${currencyNegativeAndPositiveMask(i.purchaseValue)}`,
      installmentValue: `R$ ${currencyNegativeAndPositiveMask(i.installmentValue)}`,
      amountToReceive: `R$ ${currencyNegativeAndPositiveMask(i.amountToReceive)}`,
      mdrFee: `${i.mdrFee} %`,
      salesChannel: i.salesChannel,
      nickname: i.nickname,
      nsu: i.nsu,
      statusTransaction: statusTransactionDisplay[i?.statusTransaction] ?? "",
      category: i?.category ?? "",
    });
  });
  return items;
};

export const HeaderSales = [
  {
    label: 'Descrição EC',
    key: 'companyName',
  },
  {
    label: 'CNPJ',
    key: 'companyCode',
  },
  {
    label: 'Número cartão',

    key: 'cardNumber',
  },
  {
    label: 'Data venda',
    key: 'purchaseDate',
  },
  {
    label: 'Hora da venda',
    key: 'purchaseTime',
  },
  {
    label: 'Valor bruto total',
    key: 'purchaseValue',
  },
  {
    label: 'Valor bruto parcela',
    key: 'installmentValue',
  },
  {
    label: 'Plano venda',
    key: 'purchasePlan',
  },
  {
    label: 'Parcelas',
    key: 'installments',
  },
  {
    label: 'Data vencimento parcela',
    key: 'dueDate',
  },
  {
    label: 'Valor líquido',
    key: 'amountToReceive',
  },
  {
    label: 'Condição repasse',
    key: 'repassCondition',
  },
  {
    label: 'Data repasse',
    key: 'receiptDate',
  },
  {
    label: 'Taxa de Administração (MDR)',
    key: 'mdrFee',
  },
  {
    label: 'NSU Integrador',
    key: 'nsuIntegrator'
  },
  {
    label: 'NSU Tef',
    key: 'nsuTef',
  },
  {
    label: "Canal de vendas",
    key: "salesChannel"
  },
  {
    label: "Nome fantasia",
    key: "nickname"
  },
  {
    label: 'NSU',
    key: 'nsu'
  },
  {
    label: 'Status',
    key: 'statusTransaction'
  },
  {
    label: 'Categoria do cartão',
    key: 'category'
  },
  {
    label: 'Classificação C5',
    key: 'c5Classification'
  }
];

export const BodyRepass = (data: RepassObject[]) => {
  const items = [];

  data?.forEach((i) => {
    items.push({
      ...i,
      totalAmount: `R$ ${currencyNegativeAndPositiveMask(i.totalAmount)}`,
      receiptDate: moment(i.receiptDate).format('DD/MM/YYYY'),
      nsuIntegrator: i.nsuIntegrator,
      nsuTef: i.nsuTef,
      nsu: i.nsu,
    });
  });
  return items;
};
